module.exports = __webpack_public_path__ + "img/page3_blur.88b44c66.png";